export interface OfflineAuthToken {
  expires: Date;
}

export const OFFLINE_DATA_KEY_PREFIX = 'pepper';

export enum OfflineData {
  AuthToken = 'AuthToken',
  BackgroundSync = 'BackgroundSync',
  BatchTagPrinting = 'BatchTagPrinting',
  CreditRequestData = 'CreditRequestData',
  DataStatus = 'DataStatus',
  MinimalVariantPack = 'MinimalVariantPack',
  OrderConstraints = 'OrderConstraints',
  OrderContext = 'OrderContext',
  OrderGuide = 'OrderGuide',
  OrderGuidePriceEditDisplayInfo = 'OrderGuidePriceEditDisplayInfo',
  PriceEdits = 'PriceEdits',
  QueuedOrders = 'QueuedOrders',
  RestaurantsWithQueuedOrders = 'RestaurantsWithQueuedOrders', // global queued orders
  UserBackgroundSync = 'UserBackgroundSync',
  UserContext = 'UserContext',
  VariantPackInfo = 'VariantPackInfo',
  VisibleVariantPackIDs = 'VisibleVariantPackIDs',
  VisibleVariantPacks = 'VisibleVariantPacks',
}

export enum OfflineSyncType {
  BatchTagPrinting = 'BATCH_TAG_PRINTING',
  CreditRequest = 'CREDIT_REQUEST',
  MinimalVariantPack = 'MINIMAL_VARIANT_PACK',
  OrderConstraints = 'ORDER_CONSTRAINTS',
  OrderContext = 'ORDER_CONTEXT',
  OrderGuide = 'ORDER_GUIDE',
  PriceEditDisplayInfo = 'PRICE_EDIT_DISPLAY_INFO',
  UserContext = 'USER_CONTEXT',
  VariantPackInfo = 'VARIANT_PACK_INFO',
  VisibleVariantPacks = 'VISIBLE_VARIANT_PACKS',
}

export interface OrderContextParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface OrderGuideParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface OrderConstraintsParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface OrderGuidePriceEditDisplayInfoParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface QueuedOrdersParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface BatchTagPrintingParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface UserContextParams {
  userUUID: string;
}

export interface VariantPackInfoParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface VisibleVariantPacksParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface CreditRequestDataParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface VisibleVariantPackIDsParams {
  restaurantUUID: string;
  supplierUUID: string;
}

export interface MinimalVariantPackParams {
  supplierUUID: string;
}

export interface OfflineParams {
  [OfflineData.AuthToken]: null;
  [OfflineData.BackgroundSync]: null;
  [OfflineData.BatchTagPrinting]: BatchTagPrintingParams;
  [OfflineData.CreditRequestData]: CreditRequestDataParams;
  [OfflineData.DataStatus]: null;
  [OfflineData.OrderConstraints]: OrderConstraintsParams;
  [OfflineData.OrderContext]: OrderContextParams;
  [OfflineData.OrderGuide]: OrderGuideParams;
  [OfflineData.OrderGuidePriceEditDisplayInfo]: OrderGuidePriceEditDisplayInfoParams;
  [OfflineData.PriceEdits]: null;
  [OfflineData.QueuedOrders]: QueuedOrdersParams;
  [OfflineData.RestaurantsWithQueuedOrders]: null;
  [OfflineData.MinimalVariantPack]: MinimalVariantPackParams;
  [OfflineData.UserBackgroundSync]: null;
  [OfflineData.UserContext]: UserContextParams;
  [OfflineData.VariantPackInfo]: VariantPackInfoParams;
  [OfflineData.VisibleVariantPackIDs]: VisibleVariantPackIDsParams;
  [OfflineData.VisibleVariantPacks]: VisibleVariantPacksParams;
}
